import { DeviceMeasurementsStateType } from './state'

export interface DeviceMeasurementsGettersType {
  getDeviceMeasurementsById: (state: DeviceMeasurementsStateType, id: string) => DeviceMeasurementsStateType['singleDeviceMeasurements']
  //getDeviceMeasurementsByDeviceId: (state: DeviceMeasurementsStateType, deviceId: string) => DeviceMeasurementsStateType['deviceMeasurements']
}

export const DeviceMeasurementsGetters = {
  getDeviceMeasurementsById: (state: DeviceMeasurementsStateType) => (id: string) => {
    return state.deviceMeasurements.find(data => data.id === id)
  },
  // getDeviceMeasurementsByDeviceId: (state: DeviceMeasurementsStateType) => (deviceId: string) => {
  //   return state.deviceMeasurements.filter(data => data.deviceId === deviceId)
  // },
}
